export const formatterPercent = (row, column, cellValue, index) => {
  return (null != cellValue && '' != cellValue ? parseInt(cellValue).toLocaleString() : cellValue) + ' %'
}
